/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingcrosspostdescription3Inputs */

const en_crosspostingcrosspostdescription3 = /** @type {(inputs: Crosspostingcrosspostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish one post to all connected accounts at once.`)
};

const de_crosspostingcrosspostdescription3 = /** @type {(inputs: Crosspostingcrosspostdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentliche einen Beitrag gleichzeitig auf allen verbundenen Konten.`)
};

/**
* | output |
* | --- |
* | "Publish one post to all connected accounts at once." |
*
* @param {Crosspostingcrosspostdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcrosspostdescription3 = /** @type {((inputs?: Crosspostingcrosspostdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcrosspostdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcrosspostdescription3(inputs)
	return de_crosspostingcrosspostdescription3(inputs)
});
export { crosspostingcrosspostdescription3 as "crosspostingCrossPostDescription" }